import { AfterViewInit, Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { DataRepositoryService } from "src/app/shared/services/data-repository/data-repository.service";
import { DataAccessService } from "src/app/shared/services/data-access/data-access.service";

@Component({
    selector: "app-gantt",
    templateUrl: "./gantt.component.html",
    styleUrls: ["./gantt.component.scss"],
    standalone: false
})
export class GanttComponent implements AfterViewInit, OnInit {
  subscription: Subscription[] = [];
  routeList: any = [];
  loading = false;
  taskid: string = "";

  constructor(
    private readonly dataRepoService: DataRepositoryService,
    private readonly dataAccessService: DataAccessService
  ) {
    /**
     * This filter subscription is executed when BL is changed from filter
     */
    this.dataAccessService.fitlerApplied$.subscribe((data) => {
      if (data) {
        //filter BL change is triggered, planned data gets cleared.
        this.loading = true;
        this.setRouteList();
      }
    });
    /**
     * Is used on Intitalization
     */
    this.dataAccessService.kpiData$.subscribe((res) => {
      try {
        if (res) {
          this.loading = true;
          this.setRouteList();
        }
      } catch (error) {}
    });

    this.dataAccessService.kpiDeltaUpdates$.subscribe((res) => {
      try {
        if (res) {
          this.loading = true;
          this.setRouteList();
        }
      } catch (error) {}
    });
  }

  ngOnInit(): void {
    this.loading = true;
    try {
      if (!this.dataRepoService.kpiDataMap.size) {
        this.dataAccessService.getKPIData();
      }
    } catch (error) {
      console.error("No Data");
    }
  }

  ngAfterViewInit(): void {
    this.setRouteList();
  }

  /**
   * Set Route List
   */
  setRouteList() {
    if (this.dataRepoService.kpiDataMap.size > 0) {
      const data = [...this.dataRepoService.kpiDataMap.values()];
      this.routeList = data.filter(
        (x) =>
          x.kpi.items.loaded !== 0 ||
          x.kpi.items.delivered !== 0 ||
          x.kpi.items.failedattempt !== 0 ||
          x.kpi.items.planned !== 0
      );
    } else {
      this.routeList = [];
    }
    this.loading = false;
  }
}

export enum DateType {
  begin = "begin",
  end = "end",
}

export interface Column {
  field: string;
  header: string;
}